export default {
  namespaced: true,
  state: {
    error: null,
  },
  mutations: {
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
  },
}
